module.exports = __webpack_public_path__ + "img/face-img.c5b90342.png";